import { useTranslation } from "@/i18n/useTranslation";
import { utilityRouteCopy } from "@/content/utilityRouteCopy";

const SkipLink = () => {
  const { locale } = useTranslation();
  const copy = utilityRouteCopy.skipLink[locale];

  return (
    <a href="#main-content" className="skip-link">
      {copy.label}
    </a>
  );
};

export default SkipLink;
